import axios from '@/api/axios'
// import _ from 'lodash'

const apiUrlEx = '/v1/issue'

const list = async (curPage, sk, result) => {
  let finalData = {
    items: {},
    totalPage: 0
  }
  const options = {
    method: 'GET',
    url: apiUrlEx,
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    params: {
      page: curPage,
      sk: sk
    }
  }

  await axios(options)
    .then((response) => {
      if (response.data.code === 100) {
        finalData.items = response.data.data
        finalData.totalPage = response.data.paginate.totalPage
        result(finalData)
      } else {
        result(null)
      }
    })

}

const issueMonthCount = async (seq, sdate, edate, result) => {
  let finalData = []

  const options = {
    method: 'GET',
    url: apiUrlEx + '/issue-month-count',
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    params: {
      seq: seq,
      sdate: sdate,
      edate: edate
    }
  }

  await axios(options)
    .then((response) => {
      if (response.data.code === 100) {
        finalData = response.data.data
        result(finalData)
      } else {
        result(null)
      }
    })
}

const issueDayList = async (seq, date, result) => {
  const options = {
    method: 'GET',
    url: apiUrlEx + '/issue-day-list',
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    params: {
      seq: seq,
      date: date
    }
  }

  await axios(options)
    .then((response) => {
      if (response.data.code === 100) {
        result(response.data.data)
      } else {
        result(null)
      }
    })
}

const getStillcut = async (cseq, iseq, date, result) => {
  const options = {
    method: 'GET',
    url: apiUrlEx + '/get-stillcut',
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    params: {
      cseq: cseq,
      iseq: iseq,
      date: date
    }
  }

  await axios(options)
    .then((response) => {
      if (response.data.code === 100) {
        result(response.data.data)
      } else {
        result(null)
      }
    })
}

const historyIssue = async (cseq, sdate, edate, page, result) => {
  let finalData = {
    items: {},
    totalPage: 0
  }
  const options = {
    method: 'GET',
    url: apiUrlEx + '/history-issue',
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    params: {
      cseq: cseq,
      sdate: sdate,
      edate: edate,
      page: page || 1
    }
  }

  await axios(options)
    .then((response) => {
      if (response.data.code === 100) {
        finalData.items = response.data.data
        finalData.totalPage = response.data.paginate.totalPage
        result(finalData)
      } else {
        result(null)
      }
    })
}

export default {
  list,
  issueMonthCount,
  issueDayList,
  getStillcut,
  historyIssue
}

export {}
